import { TypeActionScene } from "./actionScenes";
export var checkHasAssetDependencies = function (scene) { return function (path) { return function (action, state$, deps) {
    var isActionRequestSwap = action.type === TypeActionScene.RequestSwap;
    var scenesMatch = action.sceneId === scene.sceneId;
    var hasDependencies = scene.assetBundleDependencies != undefined && scene.assetBundleDependencies.length > 0;
    var hasAssetDependencies = isActionRequestSwap && scenesMatch && hasDependencies;
    return hasAssetDependencies ? path : undefined;
}; }; };



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/checkHasAssetDependencies.ts
// module id = 2127
// module chunks = 3